import { api } from "../api";

export type SetupPhase = "CONFIGURATION" | "ADMINISTRATOR" | "MFA" | "ACTIVE";

export interface SetupStatus {
  mode: "SETUP" | "ACTIVE";
  phase: SetupPhase;
  restartError?: string | null;
}

export interface ManagedConfiguration {
  database: {
    host: string;
    port: number;
    database: string;
    username: string;
    password: string;
    sslMode: string;
  };
  valkey: {
    host: string;
    port: number;
    username: string;
    password: string;
    tls: boolean;
    clearPassword: boolean;
  };
  platform: {
    name: string;
    publicUrl: string;
    trustedProxies: string[];
    termsVersion: string;
    privacyVersion: string;
  };
  mail: {
    enabled: boolean;
    host: string;
    port: number;
    username: string;
    password: string;
    fromAddress: string;
    fromName: string;
    emailWebhookSecret: string;
  };
  challenge: {
    turnstileSiteKey: string;
    turnstileSecret: string;
  };
}

export interface SecretPresence {
  databasePassword: boolean;
  valkeyPassword: boolean;
  smtpPassword: boolean;
  turnstileSecret: boolean;
  emailWebhookSecret: boolean;
}

export interface ManagedConfigurationSnapshot {
  configuration: ManagedConfiguration;
  secrets: SecretPresence;
}

export const emptySecrets: SecretPresence = {
  databasePassword: false,
  valkeyPassword: false,
  smtpPassword: false,
  turnstileSecret: false,
  emailWebhookSecret: false,
};

export function initialConfiguration(): ManagedConfiguration {
  const origin = window.location.origin === "null" ? "http://127.0.0.1:8080" : window.location.origin;
  return {
    database: {
      host: "127.0.0.1",
      port: 5432,
      database: "evileye_auth",
      username: "evileye_auth",
      password: "",
      sslMode: "disable",
    },
    valkey: {
      host: "127.0.0.1",
      port: 6379,
      username: "",
      password: "",
      tls: false,
      clearPassword: true,
    },
    platform: {
      name: "EvilEyeAuth",
      publicUrl: origin,
      trustedProxies: ["127.0.0.1/32", "::1/128"],
      termsVersion: "2026-08",
      privacyVersion: "2026-08",
    },
    mail: {
      enabled: false,
      host: "localhost",
      port: 1025,
      username: "",
      password: "",
      fromAddress: "no-reply@localhost",
      fromName: "EvilEyeAuth",
      emailWebhookSecret: "",
    },
    challenge: {
      turnstileSiteKey: "",
      turnstileSecret: "",
    },
  };
}

export function setupApi<T>(path: string, token: string, init: RequestInit = {}) {
  const headers = new Headers(init.headers);
  headers.set("Authorization", `Setup ${token.trim()}`);
  return api<T>(path, { ...init, headers, csrf: false });
}
